module.exports = __webpack_public_path__ + "static/media/millennium-dental.ad7dbefa.png";